import React, { Component } from 'react';
import '@fontsource/heebo/400.css';
import '@fontsource/heebo/500.css';
import '@fontsource/heebo/600.css';
import '@fontsource/heebo/700.css';
import './session.css';

const REMEMBERED_USERNAME_KEY = 'lifetagger.rememberedUsername';

export const validateLogin = ({ email = '', password = '' }) => {
  const errors = {};
  if (!email.trim()) errors.email = 'Enter your username or email.';
  if (!password) errors.password = 'Enter your password.';
  return errors;
};

class New extends Component {
  constructor(props) {
    super(props);
    const rememberedUsername = window.localStorage.getItem(
      REMEMBERED_USERNAME_KEY
    );
    this.state = {
      email: rememberedUsername || '',
      password: '',
      rememberMe: Boolean(rememberedUsername),
      showPassword: false,
      errors: {},
      submitting: false,
    };
  }

  componentDidMount() {
    if (typeof window.Intercom === 'function') {
      window.Intercom('boot', { app_id: 'wn943hcg' });
    }
  }

  componentDidUpdate(previousProps) {
    if (previousProps.notification !== this.props.notification) {
      this.setState({ submitting: false });
    }
  }

  handleSubmit = (event) => {
    event.preventDefault();
    const { email, password, rememberMe } = this.state;
    const errors = validateLogin({ email, password });
    if (Object.keys(errors).length) {
      this.setState({ errors });
      return;
    }

    if (rememberMe) {
      window.localStorage.setItem(REMEMBERED_USERNAME_KEY, email.trim());
    } else {
      window.localStorage.removeItem(REMEMBERED_USERNAME_KEY);
    }

    this.setState({ errors: {}, submitting: true });
    this.props.create({ email: email.trim(), password });
  };

  handleChange = (event) => {
    const { id, value } = event.target;
    this.setState((state) => ({
      [id]: value,
      errors: { ...state.errors, [id]: undefined },
    }));
  };

  togglePassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  render() {
    const { email, password, rememberMe, showPassword, errors, submitting } =
      this.state;

    return (
      <div className="login-page">
        <section className="login-story" aria-label="About LifeTagger">
          <div className="login-story__trace" aria-hidden="true">
            <span />
            <span />
            <span />
            <span />
          </div>
          <div className="login-brand">
            <img
              alt=""
              src="/images/dashboardlogo@2x.png"
              className="login-brand__mark"
            />
            <span className="login-brand__name">LifeTagger</span>
          </div>
          <div className="login-story__content">
            <p className="login-eyebrow">
              A contextual layer for the real world
            </p>
            <h1>Leave meaning where it matters.</h1>
            <p>
              Create rich experiences that people discover through place, time,
              LifeCodes, sound, and the signals around them.
            </p>
          </div>
          <div className="login-signal-card" aria-hidden="true">
            <span className="login-signal-card__dot" />
            <div>
              <strong>Context connected</strong>
              <small>Place · Time · LifeCode</small>
            </div>
          </div>
        </section>

        <section className="login-panel" aria-label="Sign in">
          <div className="login-panel__inner">
            <div className="login-brand login-brand--mobile">
              <img
                alt=""
                src="/images/dashboardlogo@2x.png"
                className="login-brand__mark"
              />
              <span className="login-brand__name">LifeTagger</span>
            </div>
            <div className="login-heading">
              <p className="login-eyebrow">Welcome back</p>
              <h2>Sign in to your account</h2>
              <p>
                Manage the experiences your organization puts into the world.
              </p>
            </div>

            <form
              className="login-form"
              onSubmit={this.handleSubmit}
              noValidate
            >
              {this.props.notification && (
                <div className="login-alert" role="alert">
                  {this.props.notification}
                </div>
              )}
              <div className="login-field">
                <label htmlFor="email">Username or email</label>
                <input
                  type="text"
                  id="email"
                  name="username"
                  autoComplete="username"
                  value={email}
                  aria-invalid={Boolean(errors.email)}
                  aria-describedby={errors.email ? 'email-error' : undefined}
                  onChange={this.handleChange}
                />
                {errors.email && (
                  <span className="login-field__error" id="email-error">
                    {errors.email}
                  </span>
                )}
              </div>
              <div className="login-field">
                <div className="login-field__label-row">
                  <label htmlFor="password">Password</label>
                  <a href="/resetpassword">Forgot password?</a>
                </div>
                <div className="login-password">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    autoComplete="current-password"
                    value={password}
                    aria-invalid={Boolean(errors.password)}
                    aria-describedby={
                      errors.password ? 'password-error' : undefined
                    }
                    onChange={this.handleChange}
                  />
                  <button
                    type="button"
                    className="login-password__toggle"
                    onClick={this.togglePassword}
                    aria-label={
                      showPassword ? 'Hide password' : 'Show password'
                    }
                  >
                    {showPassword ? 'Hide' : 'Show'}
                  </button>
                </div>
                {errors.password && (
                  <span className="login-field__error" id="password-error">
                    {errors.password}
                  </span>
                )}
              </div>
              <label className="login-remember">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(event) =>
                    this.setState({ rememberMe: event.target.checked })
                  }
                />
                <span>Remember my username</span>
              </label>
              <button
                type="submit"
                className="login-submit"
                disabled={submitting}
              >
                {submitting ? 'Signing in…' : 'Sign in'}
              </button>
            </form>
            <p className="login-register">
              New to LifeTagger? <a href="/register">Create an account</a>
            </p>
          </div>
        </section>
      </div>
    );
  }
}

export default New;
